/*
 * @Date: 2020-08-24 09:39:34
 * @Author: MX
 * @Description:
 */
// import '@babel/polyfill'
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import plugins from './plugins'
import 'normalize.css/normalize.css'
import * as filters from './utils/filters'
import directives from './utils/directives'
import baseComponents from './components'
import './mixins' // 全局mixin
import clickout from './utils/clickout'
import hasPower from './utils/accessPermission'
import * as Api from '@api/base/public'
import { AppKey } from './utils/const'

import md5 from 'js-md5'
Vue.prototype.$md5 = md5
import '@/utils/agent.vue.min'
import Base64 from 'base-64'
Vue.prototype.$Base64 = Base64
Vue.prototype.$hasPower = hasPower

const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'

function initCaptchaSDK() {
  if (window.initCaptcha) {
    try {
      const CaptchaSDK = window.initCaptcha({
        appKey: AppKey, // 腾讯验证码 appKey（必填）
        isCaptchaOpen: async function() {
          try {
            const { data, code } = await Api.isShowSlider()
            console.log('接口返回:', data)
            if (code === 1) {
              return data || false
            }
            return true
          } catch (error) { return true }
        }
      })
      window.CaptchaSDK = CaptchaSDK
    } catch (error) {
      // 容灾：创建模拟 SDK，确保业务继续运行
      window.CaptchaSDK = { init: function(callback) { const savedCallback = callback; return { show: function() { if (savedCallback && typeof savedCallback === 'function') { savedCallback({ ret: 0, ticket: 'fallback_ticket', randstr: 'fallback_randstr' }) } }, destroy: function() {} } }, enable: function() {}, disable: function() {} }
    }
  } else {
    // 容灾：如果 SDK 未加载，创建模拟 SDK，确保业务继续运行
    console.warn('⚠️ 验证码 SDK 未加载，使用容灾模式（直接返回成功）')
    window.CaptchaSDK = { init: function(callback) { const savedCallback = callback; return { show: function() { if (savedCallback && typeof savedCallback === 'function') { savedCallback({ ret: 0, ticket: 'fallback_ticket', randstr: 'fallback_randstr' }) } }, destroy: function() {} } }, enable: function() {}, disable: function() {} }
  }
}

// 先初始化 SDK，再创建 Vue 实例
initCaptchaSDK()
clickout(Vue)

// element-ui处理
// if (IS_DEVELOPMENT) {
import('./assets/theme/index.css')
const ELEMENT = require('jms-element-ui')
// Vue.use(ELEMENT)

// elementui 引入使用 国际化
import i18n from '@/i18n/index'
Vue.use(ELEMENT, {
  i18n: (key, value) => i18n.t(key, value) // 国际化
})
// }

import('./assets/style/index.scss')
import('./assets/iconfont/iconfont')

// mock数据
// if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_MOCK) import('./mock')
// 测试-注释

// 过滤器
Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

// 自定义指令
Object.keys(directives).forEach(key => Vue.directive(key, directives[key]))

// 注册全局基础组件
baseComponents.install()

// 注册插件
plugins.install()

Vue.config.productionTip = IS_DEVELOPMENT // sourcemap开启配置
Vue.config.performance = IS_DEVELOPMENT // 性能分析开启配置

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
